import React from 'react';
export function Ledger() {
  return <div className="ledger" data-id="element-205" data-mp="2it5qqo1wkt3t">
      <span data-id="element-206" data-mp="2k065yaj6nrsj">
        the model, <b data-id="element-207" data-mp="2jzodzq3jzzqf">you rent</b>
      </span>{' '}
      &nbsp;&middot;&nbsp;{' '}
      <span data-id="element-208" data-mp="2jxtu8f40qdnx">
        the engine, <b data-id="element-209" data-mp="2oyr6kb2ckdhi">you subscribe to</b>
      </span>{' '}
      &nbsp;&middot;&nbsp;{' '}
      <span data-id="element-210" data-mp="2tpzhjbjbs6ws">
        the instructions, <b className="g" data-id="element-211" data-mp="2tr15gglfwnvx">you own</b>
      </span>
    </div>;
}